import { forwardRef } from "react";
import type { ReactNode, MouseEvent, HTMLAttributes } from "react";

type PillLinkProps = HTMLAttributes<HTMLAnchorElement> & {
  href: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  theme?: "light" | "dark" | "transparent";
  className?: string;
  children: ReactNode;
  id?: string;
};

export const PillLink = forwardRef<HTMLAnchorElement, PillLinkProps>(
  function PillLink(
    { href, onClick, theme = "light", className = "", children, id, ...rest },
    ref,
  ) {
    return (
      <a
        ref={ref}
        id={id}
        href={href}
        onClick={onClick}
        className={`pill-link ${className}`.trim()}
        data-theme={theme}
        {...rest}
      >
        {children}
      </a>
    );
  },
);
